const KEY_PARTS: readonly string[] = [
  'PLK5bzEz',
  'Yqc9qKA0',
  'YRdzEvmZ',
  'Ny9XzIxd',
  'B8VS9r32',
];

const ALPHABET = '1-5_efxYzsUaWXTb3NnEPQhdD6SkOBvumJ9ZwCc2IApRFlHKLVM40tqo7iGygrj8';
const NONCE_BYTES = 4;
const CHECK_BYTES = 2;

function sealKey(): string {
  return [...KEY_PARTS].reverse().map(part => [...part].reverse().join('')).join('');
}

function fnv1a(bytes: Uint8Array, seed = 0x811c9dc5): number {
  let hash = seed >>> 0;
  for (const byte of bytes) {
    hash ^= byte;
    hash = Math.imul(hash, 0x01000193) >>> 0;
  }
  return hash;
}

function keystream(nonce: Uint8Array, length: number): Uint8Array {
  const key = new TextEncoder().encode(sealKey());
  let state = fnv1a(nonce, fnv1a(key)) || 0x9e3779b9;
  const out = new Uint8Array(length);
  for (let i = 0; i < length; i++) {
    state ^= state << 13;
    state ^= state >>> 17;
    state ^= state << 5;
    state >>>= 0;
    out[i] = (state ^ key[i % key.length]) & 0xff;
  }
  return out;
}

function checksum(nonce: Uint8Array, data: Uint8Array): Uint8Array {
  const hash = fnv1a(data, fnv1a(nonce));
  return new Uint8Array([hash & 0xff, (hash >>> 8) & 0xff]);
}

function encode(bytes: Uint8Array): string {
  let bits = 0;
  let acc = 0;
  let out = '';
  for (const byte of bytes) {
    acc = (acc << 8) | byte;
    bits += 8;
    while (bits >= 6) {
      bits -= 6;
      out += ALPHABET[(acc >>> bits) & 0x3f];
    }
  }
  if (bits > 0) out += ALPHABET[(acc << (6 - bits)) & 0x3f];
  return out;
}

function decode(text: string): Uint8Array {
  const out: number[] = [];
  let bits = 0;
  let acc = 0;
  for (const char of text) {
    const index = ALPHABET.indexOf(char);
    if (index < 0) throw new Error('Valor sellado inválido');
    acc = ((acc << 6) | index) & 0xffff;
    bits += 6;
    if (bits >= 8) {
      bits -= 8;
      out.push((acc >>> bits) & 0xff);
    }
  }
  return new Uint8Array(out);
}

function randomNonce(): Uint8Array {
  const nonce = new Uint8Array(NONCE_BYTES);
  globalThis.crypto.getRandomValues(nonce);
  return nonce;
}

export function seal(value: string): string {
  const nonce = randomNonce();
  const plain = new TextEncoder().encode(value);
  const stream = keystream(nonce, plain.length);
  const cipher = plain.map((byte, i) => byte ^ stream[i]);
  return encode(new Uint8Array([...nonce, ...cipher, ...checksum(nonce, plain)]));
}

export function unseal(sealed: string): string {
  const bytes = decode(sealed);
  if (bytes.length < NONCE_BYTES + CHECK_BYTES) throw new Error('Valor sellado inválido');
  const nonce = bytes.slice(0, NONCE_BYTES);
  const cipher = bytes.slice(NONCE_BYTES, bytes.length - CHECK_BYTES);
  const stream = keystream(nonce, cipher.length);
  const plain = cipher.map((byte, i) => byte ^ stream[i]);
  const expected = checksum(nonce, plain);
  if (expected[0] !== bytes[bytes.length - 2] || expected[1] !== bytes[bytes.length - 1]) {
    throw new Error('Valor sellado inválido');
  }
  return new TextDecoder().decode(plain);
}
